/* @flow */
import * as React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import style from './ElectroSimpleCheckbox.module.scss';

type TypeProps = {
  field: Object,
  option: { name: string, id: string },
};

/**
 * Basic `Checkbox` for `form` fields that only need to select
 * or deselect the option given in a `field` `string` Array value.
 */
class ElectroSimpleCheckbox extends React.Component<TypeProps> {
  setSelected = () => {
    const { field, option } = this.props;

    /** This temporary array is necessary since we
     * cannot modify the `field.value` array directly */
    const tempArray: Array<string> = [...field.value];
    const optionIndex: number = field.value.indexOf(option.id);

    if (optionIndex !== -1) {
      // Remove option from field.value
      tempArray.splice(optionIndex, 1);
    } else {
      // Add option to field.value
      tempArray.push(option.id);
    }

    field.set(tempArray);
  };

  render() {
    const { option, field } = this.props;

    const isSelected = field.value.includes(option.id);

    return (
      <FormControl>
        <FormControlLabel
          className={style['checkbox-label']}
          label={option.name}
          control={<Checkbox checked={isSelected} onChange={() => this.setSelected()} />}
        />
      </FormControl>
    );
  }
}

export default ElectroSimpleCheckbox;
